import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import SocialLinks from './SocialLinks';
import { useLanguage } from '../contexts/LanguageContext';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1d1d1f] text-[#f5f5f7] pt-16 pb-8">
      <div className="max-w-[980px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="flex flex-col items-start">
            <img 
              src="https://i.ibb.co/t08SkQL/6069.png"
              alt="6069 CARGO"
              className="h-[40px] mb-6"
              loading="eager"
            />
            <p className="text-sm text-[#86868b] leading-relaxed">
              {t('footer.company')}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold mb-4">{t('footer.services')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="/prices" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.prices')}
                </a>
              </li>
              <li>
                <a href="/services/business/search" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.search')}
                </a>
              </li>
              <li>
                <a href="/services/business/logistics" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.logistics')}
                </a>
              </li>
              <li>
                <a href="/services/business/forwarding" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.forwarding')}
                </a>
              </li>
              <li>
                <a href="/services/business/payment" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.payment')}
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold mb-4">{t('footer.company.title')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.about')}
                </a>
              </li>
              <li>
                <a href="/contacts" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  {t('footer.contacts')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4">{t('footer.contacts.title')}</h3>
            <ul className="space-y-3">
              <li>
                <SocialLinks variant="footer" className="justify-start" />
              </li>
              <li>
                <a href="mailto:wangban356@163.com" className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center">
                  <Mail className="w-4 h-4 mr-2" />
                  support@kitlin.ru
                </a>
              </li>
              <li>
                <a href="tel:+89104773184" className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center">
                  <Phone className="w-4 h-4 mr-2" />
                  +7 910 477-31-84
                </a>
              </li>
              <li>
                <div className="text-sm text-[#86868b] flex items-start">
                  <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0" />
                  <span>广州市荔湾区站前路113号7-8档</span>
                </div>
              </li>
              <li>
                <a
                  href="https://t.me/6069cargorussia"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center"
                >
                  Telegram
                  <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-[#424245]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#86868b]">
              {t('footer.rights')}
            </p>
            <div className="flex items-center gap-6">
              <a href="/privacy" className="text-sm text-[#86868b] hover:text-white transition-colors">
                {t('footer.privacy')}
              </a>
              <a href="/terms" className="text-sm text-[#86868b] hover:text-white transition-colors">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;